var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 8C14.375 11.5208 11.5208 14.375 8 14.375C4.47918 14.375 1.625 11.5208 1.625 8C1.625 4.47918 4.47918 1.625 8 1.625C11.5208 1.625 14.375 4.47918 14.375 8Z",
    stroke: "#FF6900",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.6908 8.85272C8.66709 9.21681 8.36486 9.5 8 9.5C7.63514 9.5 7.33291 9.21681 7.3092 8.85272L7.06757 5.14173L7.04112 4.49915C7.01869 3.95411 7.4545 3.5 8 3.5C8.5455 3.5 8.98131 3.95411 8.95888 4.49915L8.93243 5.14173L8.6908 8.85272ZM8.71038 12.2135C8.5173 12.4045 8.27869 12.5 7.99454 12.5C7.71038 12.5 7.47359 12.4045 7.28415 12.2135C7.09472 12.0226 7 11.7847 7 11.5C7 11.2153 7.09472 10.9774 7.28415 10.7865C7.47359 10.5955 7.71038 10.5 7.99454 10.5C8.27869 10.5 8.5173 10.5955 8.71038 10.7865C8.90346 10.9774 9 11.2153 9 11.5C9 11.7847 8.90346 12.0226 8.71038 12.2135Z",
    strokeWidth: 0.5,
    fill: "#FF6900"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.00260375ec4e4358498a3b6623291c9b.svg";
export { ForwardRef as ReactComponent };